import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { customToast } from 'core-lib/utils/customToast';

export const fetchDealersList = async (city) => {
  const url = `${apiConfig('oem')}/v2/test_drive/fetch-dealers`;
  const payload = {
    partner_name: 'VOLKSWAGEN',
    city: city,
  };

  const { response, error }: any = await postMethod({
    endPoint: url,
    body: payload,
  });

  if (response) {
    if (response?.data?.results) {
      return response.data.results?.map((item) => ({
        parkplusCity: item?.parkplus_city,
        partnerCity: item?.partner_city,
        partnerState: item?.partner_state,
        dealerTradeName: item?.dealer_trade_name,
        dealerId: item?.dealer_id,
      }));
    }
  }
  if (error) {
    customToast({
      label: error?.message || 'Something went wrong',
      variant: 'criticalNotPriority',
    });
  }
};
